import inMemoryJwt from "../auth/inMemoryJwt"
import { urlServer } from "../config/GlobalConstant"
import {CREATE_FRANCHISE_SUCCESS,CREATE_FRANCHISE_LOADING} from '../admin/actions/types'
import TobeFranchiseList from "../admin/components/Certifications/TobeFranchiseList";
import Swal from "sweetalert2";

const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 2000
});

export const createFranchise = (data,history) => async dispatch => {
    console.log();
    dispatch({
        type:CREATE_FRANCHISE_LOADING
    })
    await fetch(`${urlServer}franchises/create`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
      
            'Authorization': `bearer ${inMemoryJwt.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: data
    })
        .then(response => response.json())
        .then(respJson => {
            if (respJson.success === true) {
                dispatch({
                    type: CREATE_FRANCHISE_SUCCESS,
                    payload: respJson.data
                });
                Toast.fire({
                    icon: 'success',
                    title: 'Registro exitoso'
                })
                history.push(`/`)
                
            }
            else{
                if (respJson.error.code ==='MSJ016') {
                    Toast.fire({
                        icon: 'error',
                        title: "Ya existe una solicitud pendiente de aprobación"
                    });
                }
            }
        }).catch(error => {
            Toast.fire({
                icon: 'error',
                title: 'Error desconocido, comuníquese con el administrador'
            });
        })
}
export const editFranchise = (data,history) => async dispatch => {

    dispatch({
        type:CREATE_FRANCHISE_LOADING
    })
    await fetch(`${urlServer}franchises/update`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
      
            'Authorization': `bearer ${inMemoryJwt.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: data
    })
        .then(response => response.json())
        .then(respJson => {
            if (respJson.success === true) {
                console.log();
                history.push(`/Profile/${respJson.data.userID}`)
                
            }
        }).catch(error => {
            console.log()
        })
}

export const seeInventoryFranchise = (data) => async dispatch => {
    await fetch(`${urlServer}wineryinventories/get-all`, {
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJwt.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header   
    })
        .then(response => response.json())
        .then(respJson => {
            dispatch({type:"SEE_INVENTORY",payload:respJson.data})
        })
}

